export default "__VITE_ASSET__C$lx43A___"